// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uqb2","newExpiryDate":"styles_newExpiryDate__sVf-i","footer":"styles_footer__2w9kt"};